"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CampaignTodoKey = void 0;
var CampaignTodoKey;
(function (CampaignTodoKey) {
    CampaignTodoKey["Invitation"] = "invitation";
    CampaignTodoKey["MobileApp"] = "mobile_app";
    CampaignTodoKey["PostEvent"] = "post_event";
    CampaignTodoKey["CrossSell"] = "cross_sell";
    CampaignTodoKey["CheckIn"] = "check_in";
    CampaignTodoKey["CheckInManagerAppProTip"] = "checkin_manager_app_pro_tip";
    CampaignTodoKey["PaymentsTracking"] = "payments_tracking";
    CampaignTodoKey["PaymentsEventDay"] = "payments_event_day";
    CampaignTodoKey["GuestListExport"] = "guest_list_export";
})(CampaignTodoKey || (exports.CampaignTodoKey = CampaignTodoKey = {}));
